// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"_notifications_notificationWrapper__mOx-y","dotWrapper":"_notifications_dotWrapper__WqKFC"};